import { SignUp } from '../components';
import landingTwo from '../../src/assets/svg/landingTwo.svg';

const RegisterUser = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
      <section className='flex items-center justify-center w-full max-w-7xl mx-auto gap-16 lg:gap-24'>
        {/* Left side - Your SVG with improved styling */}
        <div className="hidden md:flex md:w-1/2 lg:w-2/5 justify-center">
          <div className="relative">
            {/* Background decoration */}
            <div className="absolute inset-0 bg-gradient-to-r from-green-400/10 to-blue-400/10 rounded-3xl transform rotate-3"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-blue-400/10 to-green-400/10 rounded-3xl transform -rotate-3"></div>
            
            {/* SVG Container */}
            <div className="relative bg-white/60 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-white/40">
              <img 
                src={landingTwo} 
                alt='Sign up illustration' 
                className='w-full h-auto max-w-md mx-auto' 
              />
            </div>
          </div>
        </div>

        {/* Right side - Your SignUp component */}
        <div className='w-full md:w-1/2 lg:w-2/5 max-w-md mx-auto'>
          <SignUp />
        </div>
      </section>
    </div>
  );
};

export default RegisterUser;